module.exports = __webpack_public_path__ + "4ec93f9d36185fa70b59f8bea3d33395.mp3";